import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(loc.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { state: { user: data.user }, replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [loc, nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-ink-600">Signing you in...</div>;
}
